import { useState } from "react";
import CategoriesContext from "../context/categoriesContext";
import Category from "../../entities/Category";

const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);

  function getCategories(data) {
    const categ = [];

    if (data.length) {
      data.forEach((category) => {
        categ.push(new Category(category));
      });
    }

    //sort categories by creation date before storing them in the state
    categ.sort((a, b) => Number(b.getCreationDate) - Number(a.getCreationDate));

    setCategories(categ);
  }

  function getOneCategory(id) {
    const category = categories.find((category) => category.getId === id);
    return category;
  }

  const contextValue = {
    categories,
    getCategories,
    getOneCategory,
  };

  return (
    <CategoriesContext.Provider value={contextValue}>
      {children}
    </CategoriesContext.Provider>
  );
};

export default CategoriesProvider;
